export class SimmModels {
  id: number;
  number?: number;
  user: string;
  status: any;
  allocatedData: string;
  userId?:number;
}
